import React, { useEffect, useRef, useState } from 'react'
import Tab from 'components/common/Tab';
import { constant } from 'constants/constant';
import DocumentOverview from '../DocumentOverview';
import VehicleDocument from '../VehicleDocument';
import './mainVehicleDoc.css';

const MainVehicleDoc = () => {
    const [activeTab, setActiveTab] = useState(1);
    const vehicleDocApiRef = useRef(null);
    const [redirectFilterDetails, setRedirectFilterDetails] = useState({
        activeTab: 1,
        activeStatus: "",
        activeOwnershipNw: 1,
        doc_type_id: "",
    });

    const handleTabButtonClick = () => {
        if (vehicleDocApiRef.current) {
            vehicleDocApiRef.current();   // VehicleDocument ki API call trigger
        }
    };
    useEffect(() => {
        if (redirectFilterDetails.activeTab === 2) {
            setActiveTab(2);
        }
    }, [redirectFilterDetails]);

    const tabProps = {
        tabList: constant.truckDocumentTabs,
        callBackTab: (e) => setActiveTab(e),
        isActiveButton: false,
        tabButtonName: 'Add Documents',
        rightButton: () => { },
        activeTab: activeTab,
        isActiveExport: activeTab == 2 ? true : false,
        buttonTitle: "Export",
        exportButton: handleTabButtonClick
    };

    return (
        <div className="_trpDetail_bx mainGps_trpDetail_bx __truckVhl">
            <div className='addPr_flBx'>
                <Tab {...tabProps} invoiceBillRaiseClass="__mainVhl_cls" />

                {activeTab === 1 && (
                    <DocumentOverview
                        // redirectFilterDetails={redirectFilterDetails}
                        setRedirectFilterDetails={setRedirectFilterDetails}
                    />
                )}

                {activeTab === 2 && (
                    <VehicleDocument
                        redirectFilterDetails={redirectFilterDetails}
                        setActiveTab={setActiveTab}
                        vehicleDocApiRef={vehicleDocApiRef} />
                )}
            </div>
        </div>
    );
};

export default MainVehicleDoc;
